module.exports = __webpack_public_path__ + "img/12000.6c8709c0.jpg";